var render = function render(){var _vm=this,_c=_vm._self._c;return _c('photo-validation-error-modal',{attrs:{"name":"photo-face-low-quality-modal","title":_vm.$t('photoValidation.title.noFace'),"error-message":_vm.$t('photoValidation.text.noFace')}})
}
var staticRenderFns = []

export { render, staticRenderFns }